import { StandardPartOfferResponseDTO } from '@luminovo/api-contracts';

export function extractOnOrderQuantity(inventoryOffers: StandardPartOfferResponseDTO[]): number {
    return inventoryOffers.reduce(
        (acc, offer) => acc + offer.availability.on_order.reduce((acc, v) => acc + v.quantity, 0),
        0,
    );
}
